module.exports = __webpack_public_path__ + "static/media/ball.4933303b.gif";